module.exports = __webpack_public_path__ + "static/img/pic_2.c2ec666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quiz/pic_2.png
// module id = we6l
// module chunks = 37